import { createSlice } from "@reduxjs/toolkit";
import MeetingTypes from "@client.enums/meetingTypes";
import DateTypes from "@client.enums/dateTypes";
import { getDateFrom, getDateTo } from "@client.components/Charts/utils";
import UserNotificationTypes from "@client.enums/userNotificationTypes";

const initialState = {
  filter: {
    dateType: DateTypes.Last30Days,
    dateFrom: getDateFrom(Number(DateTypes.Last30Days)),
    dateTo: getDateTo(Number(DateTypes.Last30Days)),
    meetingType: MeetingTypes.All,
    team: null,
    email: null,
    insightType: UserNotificationTypes.All,
  },
};

export const topChartFiltersSlice = createSlice({
  name: "topChartFilters",
  initialState,
  reducers: {
    setFilter: (state, action) => {
      state.filter = { ...state.filter, ...action.payload, email: null };
    },
  },
});

export const { setFilter } = topChartFiltersSlice.actions;

export const makeFilter = (state) => state.chartFilters.filter;

export default topChartFiltersSlice.reducer;
